import { useEffect, useRef } from 'react';

const useOutsideClick = (callback: () => void, deps: any[] = []) => {
  const ref = useRef<any>();

  useEffect(() => {
    const handleClick = (event: Event) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [ref, ...deps]);

  return ref;
};

export default useOutsideClick;
